import React, { useState } from "react";
import { Box, Grid, makeStyles, Tab, Tabs } from "@material-ui/core";
import { useSelector } from "react-redux";
import { MENU_CONTRATACIONES, SUBTIPO_EFECTORES } from "../../../utils/constants";
import { InfoLegales } from "./InfoLegales";
import { DocumentacionLegales } from "./DocumentacionLegales";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const LegalesContrataciones = (props) => {
  const { dataContrato } = useSelector((state) => state.contrataciones);

  const [value, setValue] = useState(dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.EVENTUAL ? 5 : 0);
  const classes = useStyles();

  const fieldsDisabled = props.menu === MENU_CONTRATACIONES.CONSULTA;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Grid container justify="center">
        <Grid item xs={12} md={10}>
          <Tabs variant="scrollable" scrollButtons="auto" value={value} onChange={handleChange} aria-label="simple tabs example">
            <Tab label="Información Legal" {...a11yProps(0)} value={0} />
            <Tab label="Documentación Legal" {...a11yProps(1)} value={1} />
          </Tabs>
        </Grid>
      </Grid>
      <TabPanel value={value} index={0} >
        <InfoLegales fieldsDisabled={fieldsDisabled} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DocumentacionLegales fieldsDisabled={fieldsDisabled} />
      </TabPanel>
    </div>
  );
};
